/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_GeneratingInputs */



/**
* | output |
* | --- |
* | "Wundo is preparing your topics…" |
*
* @param {Meeting_Prep_GeneratingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_generating = /** @type {((inputs?: Meeting_Prep_GeneratingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_GeneratingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo zet je voorbereiding klaar…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rédige votre préparation…")
	return /** @type {LocalizedString} */ ("Wundo is preparing your topics…")
});